import { render, staticRenderFns } from "./kpiGoals.vue?vue&type=template&id=f1e7fade&"
import script from "./kpiGoals.vue?vue&type=script&lang=js&"
export * from "./kpiGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports